import React from "react";
import { AuthLayout } from "../../layout";
import { Card } from "antd";
import { SuccessCard } from "../../components/Forms";


const SuccessPrompt = () => {
  return (
    <AuthLayout>
      <div className="flex text-center justify-center">
        <Card
          className="shadow-lg auth-card p-9 w-full lg:w-1/2"
        >
          <SuccessCard page={true}/>
        </Card>
      </div>
    </AuthLayout>
  );
};

export default SuccessPrompt;
